<template>
  <WorldMap/>
  <TopBar/>
  <SideBar/>
  <PopupDialog/>
  <NavigationSelector/>
  <LocationPopup v-if="!position.length"/>
  <ErrorToaster/>
  <a id="fullscreen" @click="toggleFullscreen" v-if="is_iframe"><span>{{ $t('map.iframe') }}</span></a>
</template>

<script>

import Bowser from "bowser";
const browser = Bowser.getParser(window.navigator.userAgent);

import WorldMap from './components/WorldMap.vue'
import TopBar from "@/components/TopBar.vue";
import SideBar from "@/components/SideBar.vue";
import PopupDialog from "@/components/PopupDialog.vue";
import NavigationSelector from "@/components/NavigationSelector.vue";
import LocationPopup from "@/components/LocationPopup.vue";

import {getAllPoints, trackEvent} from "@/scripts/api";

import ErrorToaster from "@/components/ErrorToaster.vue";

export default {
  name: 'App',
  components: {
    ErrorToaster,
    PopupDialog,
    NavigationSelector,
    LocationPopup,
    SideBar,
    TopBar,
    WorldMap
  },
  data(){
    return {
      is_iframe: window.top !== window.self,
    }
  },
  watch:{
    $route(to, from){

      this.$store.commit('previousRoute', from.name)
    }
  },
  computed: {
    position(){
      return this.$store.state.position
    }
  },
  methods:{
    toggleFullscreen(){
      document.body.classList.toggle('is-fullscreen')
      window.parent.postMessage({ action: 'toggleFullscreen' }, '*');
    },
    addBrowserClasses(){

      if( !browser.satisfies({"internet explorer": ">11", safari: '>=13', chrome: ">=85", firefox: ">=83", edge: ">=84"}) ){

        document.body.classList.add('unsupported-browser')
      }
      else{

        document.body.classList.add(browser.getPlatformType(true).replace(' ','-'))
        document.body.classList.add(browser.getOSName(true).replace(' ','-'))
      }
    },

    catchResize(){

      document.documentElement.style.setProperty('--app-offset', `${window.visualViewport.offsetTop}px`);
      document.documentElement.style.setProperty('--app-height', `${window.visualViewport.height}px`);
    },
    async getMarkers(){

      let markers = await getAllPoints();

      this.$store.commit('markers', markers)
      this.emitter.emit('markersReady');
    }
  },
  mounted(){

    document.body.classList.remove('loading');
    document.body.classList.add('loaded');

    document.documentElement.style.setProperty('--app-init-height', `${window.visualViewport.height}px`);

    trackEvent('page_view',{
      'page_location': document.location.pathname,
      'page_title': document.title,
      'page_language': document.documentElement.lang
    });

    this.$store.dispatch('load');

    this.catchResize();
    this.getMarkers();

    setTimeout(this.catchResize,200)
  },
  created() {

    window.addEventListener('resize', this.catchResize);
    window.visualViewport.addEventListener('resize', this.catchResize);

    document.addEventListener('click', (e) => {

      if(e.target.id !== 'fullscreen' && document.body.classList.contains('mobile') ){
        document.body.classList.remove('is-fullscreen')
        window.parent.postMessage({ action: 'goFullscreen' }, '*');
      }
    })

    this.addBrowserClasses();
  }
}
</script>

<style lang="scss">

@import "styles/reset";

/*
* Core
*/

@import "styles/core/animations";
@import "styles/core/grid";
@import "styles/core/gutemberg";
@import "styles/core/has-sizer";
@import "styles/core/layout";
@import "styles/core/responsive";
@import "styles/core/text";
@import "styles/core/theme";
@import "styles/core/unsupported-browsers";

/*
* Misc
*/

@import "styles/misc/fonts";
@import "styles/misc/keyframes";
@import "styles/misc/media-queries";

/*
* Vendors
*/

@import "styles/vendor/vuejs";

#fullscreen{
  position: absolute; left: $space-m ; bottom: $space; background: $c-black; color: $c-white; border-radius: $space;
  z-index: 99999; padding: $space-s $space; display: inline-flex; align-items: center; cursor: pointer; transition: allow(transform, $animation-duration);
  .sidebar-active &{ transform: translateX(39rem) }
  @media #{$to-phone} {
    bottom: auto; top: $space; transform: none!important; left: $space; background: $c-white; padding: 10px; box-shadow: $box-shadow;
    span{ display: none }
  }
  &:before{
    display: inline-block; width: 2rem; height: 2rem; content: ''; background: url("assets/picto/frame.svg") no-repeat center;
    background-size: contain; margin-right: 1rem;
    .is-fullscreen &{ background-image: url("assets/picto/frame-invert.svg"); }
    @media #{$to-phone} {
      background-image: url("assets/picto/frame-black.svg"); margin-right: 0;
      .is-fullscreen &{ background-image: url("assets/picto/frame-black-invert.svg"); }
    }
  }
}

</style>
